/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing */

import {first} from "rxjs/operators";

import { ElementRef }         from '@angular/core';

import { Dialog }             from './dialog';
import { Logger }             from '@/util/logger';

import { IValidatorCallBack } from './i.validator.call.back';
import { IOkCallBack        } from './i.ok.call.back';
import { SimulationJob }      from '@/models/sim/simulation.job';
import { SimpleSimJob }       from '@/models/sim/simple.sim.job';
import {SimConfig}            from '@/models/sim/sim.config';
import {errorAsText, isset} from "@/util/util";
import {ServiceManager}       from "@/services/service.manager";

import * as $                 from 'jquery';

/**
 *
 * @class SimDetailsDialog
 *
 * @brief helper dialog to show the various details for a remote line simulator run
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class SimDetailsDialog extends Dialog {

  /** the job we are displaying the details for */

  private job: SimulationJob = null;

  /** our router to get access to any of the services we might need. */
  private services: ServiceManager;

  /** standard constructor, allow for partial alert to be given */
  constructor(
    host: ElementRef,
    services: ServiceManager
  ) {

    super(host);

    this.services  = services;
    this.title     = 'Sim Result Details';
    this.icon      = '<i class="fas fa-info"></i>';

    Logger.debug('[SimDetailsDialog] setting up...');

    this.hasOk     = true;
    this.hasCancel = false;
    this.job       = null;

  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    let sdd: SimDetailsDialog = this;

    sdd.validator = validator ? validator : null;
    sdd.success   = success   ? success   : null;

    sdd.hasOk     = true;
    sdd.hasCancel = false;

    if (options) {

      if (options.job) {

        sdd.job = options.job;
      }
    }

    Logger.debug('[SimDetailsDialog] opening:', sdd.job);

    const body = $(sdd.host).find('.modal-body');

    const modal = $(sdd.host).parent('.modal');

    const html = `
<div class="sim-job-details-wrapper">

  <ul class="nav nav-pills" id="sim-details-nav-tab">

    <li class="nav-item active"><a class="nav-link active" id="result-meta-tab" data-toggle="tab" href="#result-nav-meta">Meta</a></li>
    <li class="nav-item active"><a class="nav-link" id="result-timing-tab" data-toggle="tab" href="#result-nav-timing" >Timing</a></li>
    <li class="nav-item active"><a class="nav-link" id="result-progress-tab" data-toggle="tab" href="#result-nav-progress" >Progress</a></li>
    <li class="nav-item active"><a class="nav-link" id="result-log-tab" data-toggle="tab" href="#result-nav-log" >Log</a></li>
    <li class="nav-item active"><a class="nav-link" id="result-errors-tab" data-toggle="tab" href="#result-nav-errors" >Errors</a></li>
    <li class="nav-item active"><a class="nav-link" id="result-extra-tab" data-toggle="tab" href="#result-nav-extra" >Extra</a></li>

  </ul>

  <div class="tab-content clearfix" id="sim-details-nav-tab-content">

    <!-- metadata -->

    <div class="tab-pane" id="result-nav-meta">
      <table class="table" style="color: #ffffff; height: 500px; overflow-y: auto; display: block;">
        <thead>
          <tr>
            <th>Property</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
        </tbody>
      </table>
    </div>

    <!-- timing details -->

    <div class="tab-pane" id="result-nav-timing">Timing</div>

    <!-- simulation progress -->

    <div class="tab-pane" id="result-nav-progress">Progress</div>

    <!-- the raw log from the simulation -->

    <div class="tab-pane" id="result-nav-log">Please Wait...</div>

    <!-- any reported problems running the simulation -->

    <div class="tab-pane" id="result-nav-errors">Please Wait...</div>

   <!-- any extra meta data (raw) -->

    <div class="tab-pane" id="result-nav-extra">Please Wait...</div>

  </div>

</div>`;

    $(body).html(html);

    /* - - - - - - fill in the meta tab - - - - - - - - - */

    const metaData: [string, string][] = [];

    const ssj: SimpleSimJob = sdd.job as SimpleSimJob;

    metaData.push(['Name',         ssj.extra.name]);
    metaData.push(['Status',       SimulationJob.statusString(ssj.details.status)]);
    metaData.push(['Progress',     ssj.progress + '%']);
    metaData.push(['Last Error',   ssj.lastError]);
    metaData.push(['Created',      ssj.details.created_at.toString()]);
    metaData.push(['Dequeued',     ssj.details.dequeue_at.toString()]);
    metaData.push(['Updated',      ssj.details.updated_at.toString()]);
    metaData.push(['Dispatch',     SimConfig.dispatchString(ssj.config.dispatch)]);
    metaData.push(['Lockup Hours', ssj.config.lockupHours.toString()]);
    metaData.push(['Log Level',    SimConfig.logLevelString(ssj.config.logLevel)]);
    metaData.push(['Log Level',    ssj.config.maxDays.toString()]);
    metaData.push(['Permissive',   (ssj.config.permissive ? 'YES' : 'NO')]);
    metaData.push(['Priority',     ssj.config.priority.toString()]);
    metaData.push(['MD5',          ssj.extra.md5]);
    metaData.push(['RIPEMD160',    ssj.extra.ripemd160]);

    let metaHTML = '';

    metaData.forEach((i: [string,string]) => {

      metaHTML += `<tr><td>${i[0]}</td><td>${i[1]}</td></tr>`;
    });

    $(`#result-nav-meta tbody`).append(metaHTML);

    /* - - - - - - fill in the timing tab - - - - - - - - - */


    let timing: string =  `<table class="table" style="color: #ffffff; height: 500px; overflow-y: auto; display: block;">
      <thead>
        <tr>
          <th>Property</th>
      <th>Value</th>
      </tr>
      </thead>
      <tbody>`;

    timing += `<tr><td>Queued</td><td>${ssj.details.waittime}</td></tr>`;
    timing += `<tr><td>Simulation</td><td>${ssj.details.runtime}</td></tr>`;

    if (isset(ssj.extra.milliseconds)) {

      timing += `<tr><th colspan="2">Detailed Timing (milliseconds):</th></tr>`;

      timing += `<tr><td>Init / Other</td><td>${ssj.extra.milliseconds.init_validation_build_other}</td></tr>`;
      timing += `<tr><td>Validation</td><td>${ssj.extra.milliseconds.validation}</td></tr>`;
      timing += `<tr><td>Model Build</td><td>${ssj.extra.milliseconds.model_build}</td></tr>`;
      timing += `<tr><td>Database Save</td><td>${ssj.extra.milliseconds.db_save}</td></tr>`;
      timing += `<tr><td>JSON Save</td><td>${ssj.extra.milliseconds.json_output}</td></tr>`;
      timing += `<tr><td>Total</td><td>${ssj.extra.milliseconds.total}</td></tr>`;
    }

    if (isset(ssj.extra.counters)) {

      timing += `<tr><th colspan="2"> Event Counts:</th></tr>`;

      timing += `<tr><td>Train Creation</td><td>${ssj.extra.counters.train_crt}</td></tr>`;
      timing += `<tr><td>Train Arrivals</td><td>${ssj.extra.counters.train_arr}</td></tr>`;
      timing += `<tr><td>Train Finish</td><td>${ssj.extra.counters.train_fin}</td></tr>`;
      timing += `<tr><td>Switch Clearance</td><td>${ssj.extra.counters.sw_clr}</td></tr>`;
      timing += `<tr><td>Clear to Stop</td><td>${ssj.extra.counters.sw_clr_stop}</td></tr>`;
      timing += `<tr><td>Advanced to Stop</td><td>${ssj.extra.counters.sw_adv_stop}</td></tr>`;
    }

    timing += `</tbody></table>`;

    $(`#result-nav-timing`).html(timing);

    /* - - - - - - fill in the progress tab - - - - - - - - - */

    let progress: string = '';

    if (isset(ssj.details) && isset(ssj.details.progress_out)) {

      let lines: string[] = ssj.details.progress_out as string[];

      progress = lines.map(
        x => x.replace(
          /(^|\n|\\n)(\[\s*\d+\s*])\s/g,
          '\n<span style="color: #ffffff;">$2</span>')
      ).join('\n');

    }

    progress = progress.replace(/\\n/g, '</br>');
    progress = progress.replace(/\n/g, '</br>');

    let progressHTML: string = `
<div style="height: 500px; overflow-y: auto; font-family: 'Courier New', monospace, 'Lucida Sans Unicode';">
${progress}
</div>`;

    $(`#result-nav-progress`).html(progressHTML);

    /* for the log file, we have to fetch the artifact, so it will be filled in after the dialog pops up */

    $(`#result-nav-log`).html('Please Wait...');

    sdd.services.linesim.artifactContents(sdd.job.artifactURL('log'))
      .pipe(first())
      .subscribe({
        next: (content: string): void => {

          content = content.replace(/\\n/g, '</br>');
          content = content.replace(/\n/g, '</br>');

          let logHTML: string = `
<div style="height: 500px; text-wrap: nowrap; overflow: auto; font-family: 'Courier New', monospace, 'Lucida Sans Unicode';">
${content}
</div>`;

          $(`#result-nav-log`).html(logHTML);

        },
        error: (err): void => {

          Logger.error(`[SimDetailsDialog] could not fetch 'log' file contents: `, errorAsText(err));
        }

      });

    /* for the errors file, we have to fetch the artifact, so it will be filled in after the dialog pops up */

    $(`#result-nav-errors`).html('Please Wait...');

    sdd.services.linesim.artifactContents(sdd.job.artifactURL('errors'))
      .pipe(first())
      .subscribe({
        next: (content: string): void => {

          content = content.replace(/\\n/g, '</br>');
          content = content.replace(/\n/g, '</br>');

          let errorsHTML: string = `
<div style="height: 500px; text-wrap: nowrap; overflow: auto; font-family: 'Courier New', monospace, 'Lucida Sans Unicode';">
${content}
</div>`;

          $(`#result-nav-errors`).html(errorsHTML);


        },
        error: (err): void => {

          Logger.error(`[SimDetailsDialog] could not fetch 'errors' file contents: `, errorAsText(err));
        }

      });

    /* fill in the raw metadata */

    let metaString: string = JSON.stringify(sdd.job.details.extra, null, 2);

    $(`#result-nav-extra`).html(`
<div style="white-space: pre; height: 500px; text-wrap: nowrap; overflow: auto; font-family: 'Courier New', monospace, 'Lucida Sans Unicode';">
      ${metaString}
      </div>`);

    /* start with the meta tab shown */

    // @ts-ignore
    $('#result-nav-meta').tab('show');

    $('#sim-details-nav-tab a').on('click', function (e) {
      e.preventDefault();
      // @ts-ignore
      $(this).tab('show');
    });
  }

  /** dialog is closing */
  public close(): void {

    Logger.debug('[SimDetailsDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[SimDetailsDialog] accepted.');

    if (this.success) {

      /* inform the client */

      this.success();
    }

  }
}
